import { format as formatDate} from 'date-fns';
import DateHelper from 'app/helpers/dateHelper';
import { isDefined } from 'app/helpers/objectHelper';

export const DateTimeDisplay = (value:string|undefined) => (
    !isDefined(value) ? '-' : formatDate(DateHelper.ToDate(value),'dd MMM yyyy h:mma')
)